/* Tungsten Edge — theme behaviours.
   Every block guards on element presence so this one file is safe on every template. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header state, scroll progress, back to top ---------- */
  var header = $('.site-header');
  var progress = $('#ScrollProgress');
  var toTop = $('#ToTop');

  function onScroll() {
    var y = window.scrollY;
    if (header) header.classList.toggle('is-scrolled', y > 10);
    if (progress) {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = (max > 0 ? (y / max) * 100 : 0) + '%';
    }
    if (toTop) toTop.classList.toggle('is-visible', y > 700);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (toTop) {
    toTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* ---------- mobile nav ---------- */
  var menuToggle = $('#MenuToggle');
  var mobileNav = $('#MobileNav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(open));
    });
    $$('a', mobileNav).forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- search drawer ---------- */
  var searchToggle = $('#SearchToggle');
  var searchDrawer = $('#SearchDrawer');
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function () {
      var open = searchDrawer.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open) { var f = $('input[type=search]', searchDrawer); if (f) f.focus(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchDrawer.classList.contains('is-open')) {
        searchDrawer.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus();
      }
    });
  }

  /* ---------- scroll reveal + count-up + review bars ---------- */
  var revealables = $$('.reveal, .stagger');
  if (revealables.length) {
    if (!('IntersectionObserver' in window) || reduceMotion) {
      revealables.forEach(function (el) { el.classList.add('is-in'); });
      $$('[data-count]').forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
      $$('.review-bar__fill[data-w]').forEach(function (f) { f.style.width = f.getAttribute('data-w') + '%'; });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          $$('[data-count]', e.target).forEach(countUp);
          $$('.review-bar__fill[data-w]', e.target).forEach(function (f) {
            f.style.width = f.getAttribute('data-w') + '%';
          });
          io.unobserve(e.target);
        });
      }, { threshold: 0.15 });
      revealables.forEach(function (el) { io.observe(el); });
    }
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
    if (isNaN(target)) return;
    var start = performance.now(), dur = 1400;
    function tick(now) {
      var p = Math.min((now - start) / dur, 1);
      el.textContent = (target * (1 - Math.pow(1 - p, 3))).toFixed(dec);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---------- lead vs tungsten comparator ---------- */
  var slider = $('#OzSlider');
  if (slider) {
    var WEIGHTS = [
      { label: '1/8 oz', g: 3.54 }, { label: '3/16 oz', g: 5.31 }, { label: '1/4 oz', g: 7.09 },
      { label: '5/16 oz', g: 8.86 }, { label: '3/8 oz', g: 10.63 }, { label: '1/2 oz', g: 14.17 },
      { label: '5/8 oz', g: 17.72 }, { label: '3/4 oz', g: 21.26 }, { label: '1 oz', g: 28.35 },
      { label: '2 oz', g: 56.7 }
    ];
    // g/cm3. 18.0 is typical for the 97% tungsten alloy these weights are poured from;
    // lead is 11.34. Ratio ~1.6x denser, ~37% less volume for the same weight.
    var D_LEAD = 11.34, D_TUNGSTEN = 18.0, PX_PER_MM = 6.2;
    var ozValue = $('#OzValue'), ballLead = $('#BallLead'), ballTung = $('#BallTungsten');
    var leadDia = $('#LeadDiameter'), tungDia = $('#TungstenDiameter');

    function diameterMM(grams, density) {
      var volume = grams / density;
      return 2 * Math.cbrt((3 * volume) / (4 * Math.PI)) * 10;
    }
    function sizeBall(el, mm) {
      var px = Math.max(mm * PX_PER_MM, 14);
      el.style.width = px + 'px';
      el.style.height = px + 'px';
    }
    function updateComparator(i) {
      var w = WEIGHTS[i];
      if (!w) return;
      var dl = diameterMM(w.g, D_LEAD), dt = diameterMM(w.g, D_TUNGSTEN);
      if (ozValue) ozValue.textContent = w.label;
      if (ballLead) sizeBall(ballLead, dl);
      if (ballTung) sizeBall(ballTung, dt);
      if (leadDia) leadDia.textContent = '⌀ ' + dl.toFixed(1) + ' mm';
      if (tungDia) tungDia.textContent = '⌀ ' + dt.toFixed(1) + ' mm';
      // Announce the weight, not the raw slider index, to screen readers.
      slider.setAttribute('aria-valuetext', w.label);
    }
    slider.addEventListener('input', function (e) { updateComparator(parseInt(e.target.value, 10)); });
    updateComparator(parseInt(slider.value, 10));
  }

  /* ---------- product gallery ---------- */
  var gallery = $('[data-product-gallery]');
  if (gallery) {
    var mainImg = $('[data-gallery-main] > img', gallery);

    /* 3D model box (1 Nov 2026), rendered by sections/main-product.liquid only when the product has a model media
       item. Nothing downloads until the 3D thumbnail is clicked: then our model-viewer copy (a module script tag, so
       this file stays plain script) and the .glb. */
    var box3d = $('[data-gallery-3d]', gallery);
    var mv3d = null, mvLoad3d = null;
    function loadModule3d(url) {
      return new Promise(function (resolve, reject) {
        if (window.customElements && customElements.get('model-viewer')) { resolve(); return; }
        var s = document.createElement('script');
        s.type = 'module';
        s.src = url;
        s.onload = function () { customElements.whenDefined('model-viewer').then(resolve, reject); };
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    function fail3d() {
      box3d.classList.remove('is-loading', 'is-live');
      box3d.classList.add('is-failed');
      if (mv3d && mv3d.parentNode) mv3d.parentNode.removeChild(mv3d);
      mv3d = null;
      var h = $('[data-gallery-3d-hint]', box3d);
      if (h) { h.textContent = '3D view did not load. Click the 3D thumbnail to try again'; box3d.classList.add('is-hint'); }
    }
    function activate3d() {
      if (!box3d || mv3d || box3d.classList.contains('is-loading')) return;
      box3d.classList.remove('is-failed', 'is-hint');
      box3d.classList.add('is-loading');
      var bar = $('[data-gallery-3d-bar]', box3d);
      if (bar) bar.style.width = '4%';
      if (!mvLoad3d) {
        mvLoad3d = loadModule3d(box3d.getAttribute('data-mv'));
        mvLoad3d.catch(function () { mvLoad3d = null; });
      }
      mvLoad3d.then(function () {
        mv3d = document.createElement('model-viewer');
        var at = {
          'src': box3d.getAttribute('data-glb'), 'alt': box3d.getAttribute('data-alt'),
          'camera-controls': '', 'touch-action': 'pan-y', 'interaction-prompt': 'none',
          'camera-orbit': '35deg 62deg auto', 'min-camera-orbit': 'auto 0deg auto', 'max-camera-orbit': 'auto 180deg auto',
          'tone-mapping': 'neutral', 'exposure': '1', 'shadow-intensity': '0.6', 'loading': 'eager'
        };
        Object.keys(at).forEach(function (k) { mv3d.setAttribute(k, at[k]); });
        mv3d.addEventListener('progress', function (e) {
          var p = e.detail && e.detail.totalProgress;
          if (bar && p >= 0) bar.style.width = Math.max(4, Math.round(p * 100)) + '%';
        });
        mv3d.addEventListener('load', function () {
          box3d.classList.remove('is-loading');
          box3d.classList.add('is-live', 'is-hint');
        });
        mv3d.addEventListener('error', fail3d);
        function hideHint() { box3d.classList.remove('is-hint'); }
        mv3d.addEventListener('camera-change', function (e) { if (e.detail && e.detail.source === 'user-interaction') hideHint(); });
        mv3d.addEventListener('pointerdown', hideHint);
        /* a sideways trackpad swipe over the model turns it instead of scrolling the page sideways */
        mv3d.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) e.preventDefault(); }, { passive: false });
        $('[data-gallery-3d-box]', box3d).appendChild(mv3d);
      }).catch(fail3d);
    }
    function show3d(on) {
      if (!box3d) return;
      box3d.hidden = !on;
      if (mainImg) mainImg.hidden = !!on;
      if (on) activate3d();
    }
    gallery.__te3d = show3d;
    if (box3d) {
      /* "View in your space": iPhone/iPad Quick Look with Shopify's USDZ, Android Scene Viewer with the .glb */
      var ar = $('[data-gallery-ar]', box3d);
      var ua = navigator.userAgent;
      var ios = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      var arKind = '';
      if (ios) {
        var a0 = document.createElement('a');
        arKind = (a0.relList && a0.relList.supports && a0.relList.supports('ar')) ? 'ios' : '';
      } else if (/android/i.test(ua) && !/firefox|oculus|quest|pico/i.test(ua)) {
        arKind = 'android';
      }
      if (ar && arKind && (arKind === 'android' ? box3d.getAttribute('data-glb') : box3d.getAttribute('data-usdz'))) {
        ar.hidden = false;
        ar.addEventListener('click', function () {
          if (arKind === 'ios') {
            var a = document.createElement('a');
            a.setAttribute('rel', 'ar');
            a.href = box3d.getAttribute('data-usdz');
            a.appendChild(document.createElement('img'));
            a.click();
          } else {
            var page = location.href.split('#')[0];
            location.href = 'intent://arvr.google.com/scene-viewer/1.0?file=' + encodeURIComponent(box3d.getAttribute('data-glb')) +
              '&mode=ar_preferred&title=' + encodeURIComponent(box3d.getAttribute('data-title') || '') +
              '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=' +
              encodeURIComponent(page) + ';end;';
          }
        });
      }
    }

    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.hasAttribute('data-gallery-thumb-3d')) {
          show3d(true);
        } else {
          show3d(false);
          var full = thumb.getAttribute('data-full');
          if (mainImg && full) {
            mainImg.src = full;
            mainImg.removeAttribute('srcset');
          }
        }
        $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- quantity steppers ---------- */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    if (!input) return;
    $$('[data-qty-step]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = Math.max(min, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- variant picker ---------- */
  var variantForm = $('[data-variant-picker]');
  if (variantForm) {
    var variants = [];
    var dataEl = $('[data-variant-json]', variantForm);
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; } }

    var idInput = $('[data-variant-id]', variantForm);
    var priceEl = $('[data-variant-price]', variantForm);
    var compareEl = $('[data-variant-compare]', variantForm);
    var submitBtn = $('[data-add-to-cart]', variantForm);
    var stockEl = $('[data-variant-stock]', variantForm);
    var moneyFormat = variantForm.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'));
    }

    function selectedOptions() {
      return $$('[data-option-index]', variantForm)
        .filter(function (el) { return el.checked || el.getAttribute('aria-checked') === 'true'; })
        .sort(function (a, b) {
          return a.getAttribute('data-option-index') - b.getAttribute('data-option-index');
        })
        .map(function (el) { return el.value || el.getAttribute('data-value'); });
    }

    function updateVariant() {
      var chosen = selectedOptions();
      var match = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      })[0];

      if (!match) {
        if (submitBtn) { submitBtn.setAttribute('disabled', 'disabled'); submitBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (stockEl) {
        stockEl.classList.toggle('stock--out', !match.available);
        var label = $('[data-stock-label]', stockEl);
        // Labels come from the locale file via data attributes. Hardcoding them here once
        // published an unverified "ships fast" delivery promise on every product page and
        // desynced the client text from the server-rendered text.
        if (label) {
          label.textContent = match.available
            ? (stockEl.getAttribute('data-label-in') || label.textContent)
            : (stockEl.getAttribute('data-label-out') || label.textContent);
        }
      }
      if (submitBtn) {
        if (match.available) {
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = submitBtn.getAttribute('data-default-text') || 'Add to cart';
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.textContent = 'Sold out';
        }
      }
      if (match.media_id) {
        var _g = $('[data-product-gallery]');
        if (_g && _g.__te3d) _g.__te3d(false);   /* a variant change always shows its photo, not the 3D box */
        var _mi = _g && $('[data-gallery-main] > img', _g);
        var _vt = _g && $('[data-gallery-thumb][data-media-id="' + match.media_id + '"]', _g);
        if (_mi && _vt) {
          var _vf = _vt.getAttribute('data-full');
          if (_vf) { _mi.src = _vf; _mi.removeAttribute('srcset'); }
          $$('[data-gallery-thumb]', _g).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          _vt.setAttribute('aria-current', 'true');
        }
      }
      if (window.history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-option-index]', variantForm).forEach(function (el) {
      el.addEventListener('change', updateVariant);
      el.addEventListener('click', function () {
        if (el.hasAttribute('aria-checked')) {
          var idx = el.getAttribute('data-option-index');
          $$('[data-option-index="' + idx + '"]', variantForm).forEach(function (sib) {
            sib.setAttribute('aria-checked', 'false');
          });
          el.setAttribute('aria-checked', 'true');
          updateVariant();
        }
      });
    });
    updateVariant();
  }

  /* ---------- collection sort ---------- */
  var sortSelect = $('#SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- filter auto-submit ---------- */
  var filterForm = $('#FilterForm');
  if (filterForm) {
    $$('input[type=checkbox]', filterForm).forEach(function (cb) {
      cb.addEventListener('change', function () { filterForm.submit(); });
    });
  }

  /* ---------- free-shipping progress bar ---------- */
  /* Liquid computes the percentage server-side; JS only animates the fill in. */
  $$('.ship-bar__fill[data-pct]').forEach(function (fill) {
    var pct = Math.max(0, Math.min(100, parseFloat(fill.getAttribute('data-pct')) || 0));
    if (reduceMotion) { fill.style.width = pct + '%'; return; }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { fill.style.width = pct + '%'; });
    });
  });

  /* ---------- sticky mobile add-to-cart ---------- */
  var stickyAtc = $('#StickyAtc');
  var buyRow = $('[data-buy-row]');
  if (stickyAtc && buyRow && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // Show the sticky bar only once the real button has scrolled out of view.
        stickyAtc.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    atcObserver.observe(buyRow);

    var stickyBtn = $('[data-sticky-add]', stickyAtc);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var realBtn = $('[data-add-to-cart]');
        if (realBtn) realBtn.click();
      });
    }
  }

  /* ---------- cart line quantity + remove ---------- */
  $$('[data-cart-quantity]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- Judge.me review photos: defer to the section, then force-load ----------
     Measured 2026-08-03: the homepage review carousel pulled 8 customer photos at their ORIGINAL
     1024x1365 to display them at 223x225 — 681KB fetched eagerly for a section ~6,900px down the
     page, part of a 12.4s mobile LCP. The first fix set loading="lazy" on every photo.

     That fixed the page-top cost but broke mobile: the photos live in a HORIZONTALLY-scrolled
     carousel, so most photo cards never enter the vertical viewport, the native lazy load never
     fires, and the images never appear. Desktop happened to show a couple because its wider
     carousel put them in view; mobile showed none.

     Fix: keep them deferred, but gate on the SECTION with an IntersectionObserver instead of on
     each image. Nothing loads at the top of the page; once the reviews scroll near, every photo is
     forced to load regardless of its horizontal position in the carousel. Removing and reapplying
     src is what makes the browser re-fetch under the new loading rule. Judge.me injects/re-renders
     these asynchronously (and on carousel navigation), hence the MutationObserver too. */
  var reviewLive = $('.review-live');
  if (reviewLive) {
    var reviewsReached = false;

    var forceSrc = function (img) {
      var src = img.getAttribute('src');
      if (src && !img.complete) { img.removeAttribute('src'); img.setAttribute('src', src); }
    };
    var deferImg = function (img) {
      if (img.getAttribute('data-lazied')) return;
      img.setAttribute('data-lazied', '1');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      forceSrc(img);
    };
    var loadImg = function (img) {
      if (img.getAttribute('data-jdgm-loaded')) return;
      img.setAttribute('data-jdgm-loaded', '1');
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');
      forceSrc(img);
    };
    var processImages = function () {
      $$('img', reviewLive).forEach(reviewsReached ? loadImg : deferImg);
    };

    processImages();

    if ('IntersectionObserver' in window) {
      var sectionIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            reviewsReached = true;
            processImages();          // force every photo present now, off-screen carousel cards included
            sectionIO.disconnect();
          }
        });
      }, { rootMargin: '250px' });      // begin just before it reaches the viewport, so it is ready
      sectionIO.observe(reviewLive);
    } else {
      reviewsReached = true;
      processImages();
    }

    if ('MutationObserver' in window) {
      new MutationObserver(processImages)
        .observe(reviewLive, { childList: true, subtree: true });
    }
  }

  /* ---------- slide-out cart drawer ----------------------------------------------------
     ONE SUBMIT OWNER. This is the ONLY handler bound to the product buy form's submit.
     It runs in a fixed order: validate -> build line item -> add -> open the drawer.
     Do not add a second submit listener anywhere; extend THIS function instead.
     Markup: snippets/cart-drawer.liquid (rendered from the header on every page). */
  var cdRoot = $('[data-cart-drawer]');
  if (cdRoot) {
    var cdPanel   = $('.cart-drawer__panel', cdRoot);
    var cdItems   = $('[data-cd-items]', cdRoot);
    var cdEmpty   = $('[data-cd-empty]', cdRoot);
    var cdFoot    = $('[data-cd-foot]', cdRoot);
    var cdSub     = $('[data-cd-sub]', cdRoot);
    var cdShip    = $('[data-cd-ship]', cdRoot);
    var cdShipMsg = $('[data-cd-shipmsg]', cdRoot);
    var cdBarFill = $('[data-cd-barfill]', cdRoot);
    var cdRecs    = $('[data-cd-recs]', cdRoot);
    var cdRecList = $('[data-cd-reclist]', cdRoot);
    var cdBusy    = $('[data-cd-busy]', cdRoot);
    var cdError   = $('[data-cd-error]', cdRoot);
    var cdCount   = $('[data-cart-count]');

    var cdCfg = {}, cdPool = [];
    var cfgEl = $('[data-cd-config]'), poolEl = $('[data-cd-pool]');
    try { cdCfg = JSON.parse(cfgEl.textContent); } catch (e) { cdCfg = {}; }
    try { cdPool = JSON.parse(poolEl.textContent); } catch (e) { cdPool = []; }

    var THRESH   = cdCfg.threshold || 4000;
    var cartBase = String(cdCfg.cartUrl || '/cart').replace(/\/+$/, '');
    var ADD_URL  = cartBase + '/add.js';
    var CHG_URL  = cartBase + '/change.js';
    var CART_URL = cartBase + '.js';

    /* Editorial pairing map, keyed on lowercased product_type (from /cart.js). Terminal
       Tackle (EdgePegs) leads for worm/flipping — the genuine "finish the rig" add-on that
       also closes a small free-shipping gap. Finesse weights lead with the matching Bundle.
       Merch/decals point back at the core money items. Gap-fit only re-orders WITHIN a slot. */
    var CD_PAIR = {
      'worm weight':      ['Terminal Tackle', 'Bundle', 'Flipping Weight', 'Drop Shot Weight'],
      'flipping weight':  ['Terminal Tackle', 'Bundle', 'Worm Weight', 'Nail Weight'],
      'drop shot weight': ['Bundle', 'Nail Weight', 'Shaky Head', 'Wacky Weight'],
      'nail weight':      ['Bundle', 'Wacky Weight', 'Drop Shot Weight'],
      'wacky weight':     ['Bundle', 'Nail Weight', 'Drop Shot Weight'],
      'shaky head':       ['Bundle', 'Drop Shot Weight', 'Worm Weight'],
      'bundle':           ['Terminal Tackle', 'Worm Weight', 'Flipping Weight'],
      'terminal tackle':  ['Worm Weight', 'Flipping Weight', 'Bundle'],
      'apparel':          ['Bundle', 'Worm Weight', 'Flipping Weight'],
      'hat':              ['Bundle', 'Worm Weight', 'Flipping Weight'],
      'decal':            ['Bundle', 'Worm Weight', 'Flipping Weight']
    };

    function cdEsc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* shop.money_format can carry markup, so a naive replace leaves a literal ${{amount}}. */
    function cdMoney(cents) {
      var n = (cents || 0) / 100;
      var s = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var f = String(cdCfg.moneyFormat || '${{amount}}').replace(/<[^>]+>/g, '');
      if (f.indexOf('{{amount}}') > -1) return f.replace('{{amount}}', s);
      if (f.indexOf('{{ amount }}') > -1) return f.replace('{{ amount }}', s);
      return '$' + s;
    }

    function cdThumb(url) {
      if (!url) return '';
      return url.replace(/(\.(?:png|jpe?g|gif|webp))(\?|$)/i, '_120x$1$2');
    }

    function cdBusyOn(on) { if (cdBusy) cdBusy.hidden = !on; }

    function getCart() {
      return fetch(CART_URL, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function cdApi(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        // Shopify returns 422 (with a JSON body) when it adds NOTHING — e.g. requested qty
        // exceeds stock, or the item sold out since page load. r.json() alone would resolve
        // and the drawer would open showing an unchanged cart as if the add worked. Reject
        // instead, carrying Shopify's own description, so the caller can say what went wrong.
        return r.json().then(function (data) {
          if (!r.ok) { throw { cdError: true, description: (data && (data.description || data.message)) || '' }; }
          return data;
        });
      });
    }
    function cdShowError(msg) {
      if (!cdError) return;
      cdError.textContent = msg || 'Sorry — that could not be added to your cart.';
      cdError.hidden = false;
    }
    function cdClearError() { if (cdError) cdError.hidden = true; }

    function syncCount(count) {
      if (!cdCount) return;
      cdCount.textContent = count;
      if (count > 0) cdCount.removeAttribute('hidden');
      else cdCount.setAttribute('hidden', 'hidden');
    }

    function renderShip(total) {
      if (!cdShip) return;
      cdShip.hidden = false;
      var left = THRESH - total;
      if (left <= 0) {
        // Wording kept verbatim in step with the cart page (sections/main-cart.liquid).
        cdShipMsg.innerHTML = '<b>Free US shipping unlocked.</b> Nice work.';
        cdShip.classList.add('is-met');
        if (cdBarFill) cdBarFill.style.width = '100%';
      } else {
        cdShipMsg.innerHTML = 'You&rsquo;re <b>' + cdEsc(cdMoney(left)) + '</b> away from free US shipping';
        cdShip.classList.remove('is-met');
        // Clamp to a 2%..100% band so a full bar never overflows and a tiny cart still shows a sliver.
        if (cdBarFill) cdBarFill.style.width = Math.max(2, Math.min(100, (total / THRESH) * 100)) + '%';
      }
    }

    function recommend(cart) {
      var types = [];
      (cart.items || []).forEach(function (li) {
        var t = String(li.product_type || '').toLowerCase();
        if (t && types.indexOf(t) === -1) types.push(t);
      });
      var wanted = [];
      types.forEach(function (t) {
        (CD_PAIR[t] || []).forEach(function (w) { if (wanted.indexOf(w) === -1) wanted.push(w); });
      });
      if (!wanted.length) wanted = ['Bundle', 'Terminal Tackle', 'Worm Weight'];

      var seen = {}, cand = [];
      wanted.forEach(function (w, wi) {
        cdPool.forEach(function (p) {
          if (String(p.ty || '').toLowerCase() !== w.toLowerCase()) return;
          if (/gift card/i.test(p.t)) return;
          if (seen[p.u]) return;
          var inCart = (cart.items || []).some(function (li) {
            return li.url && li.url.split('?')[0] === p.u;
          });
          if (inCart) return;
          seen[p.u] = true;
          cand.push({ id: p.id, t: p.t, u: p.u, p: p.p, img: p.img, rank: wi });
        });
      });

      var gap = THRESH - (cart.total_price || 0);
      if (gap > 0) {
        cand.sort(function (a, b) {
          if (a.rank !== b.rank) return a.rank - b.rank;          // relevance (category order) wins first
          var ac = (a.p || 0) >= gap, bc = (b.p || 0) >= gap;
          if (ac !== bc) return ac ? -1 : 1;                       // then: does it close the gap
          return ac ? (a.p - b.p) : (b.p - a.p);                   // cheapest that closes it, else priciest under
        });
      }
      return cand.slice(0, 3);
    }

    function renderRecs(cart) {
      if (!cdRecs || !cdRecList) return;
      var recs = recommend(cart);
      if (!recs.length) { cdRecs.hidden = true; cdRecList.innerHTML = ''; return; }
      cdRecList.innerHTML = recs.map(function (r) {
        return '<li class="cart-drawer__rec">' +
          (r.img
            ? '<img class="cart-drawer__rec-img" src="' + cdEsc(r.img) + '" alt="" width="48" height="48" loading="lazy" decoding="async">'
            : '<span class="cart-drawer__rec-img"></span>') +
          '<div class="cart-drawer__rec-main">' +
            '<a class="cart-drawer__rec-title" href="' + cdEsc(r.u) + '">' + cdEsc(r.t) + '</a>' +
            '<span class="cart-drawer__rec-price tabular">' + cdEsc(cdMoney(r.p)) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-drawer__rec-add" data-cd-recadd data-id="' + cdEsc(String(r.id)) + '" aria-label="Add ' + cdEsc(r.t) + ' to cart">Add</button>' +
        '</li>';
      }).join('');
      cdRecs.hidden = false;
    }

    function itemHTML(li, line) {
      var variant = (li.variant_title && li.variant_title !== 'Default Title')
        ? '<div class="cart-drawer__item-variant">' + cdEsc(li.variant_title) + '</div>' : '';
      var img = cdThumb(li.image);
      return '<li class="cart-drawer__item" data-line="' + line + '">' +
        '<a class="cart-drawer__item-media" href="' + cdEsc(li.url) + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + cdEsc(img) + '" alt="" width="60" height="60" loading="lazy" decoding="async">' : '') +
        '</a>' +
        '<div class="cart-drawer__item-main">' +
          '<a class="cart-drawer__item-title" href="' + cdEsc(li.url) + '">' + cdEsc(li.product_title || li.title) + '</a>' +
          variant +
          '<div class="cart-drawer__item-row">' +
            '<div class="cart-drawer__qty">' +
              '<button type="button" data-cd-dec aria-label="Decrease quantity">&minus;</button>' +
              '<span class="cart-drawer__qty-num tabular">' + (li.quantity || 1) + '</span>' +
              '<button type="button" data-cd-inc aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="cart-drawer__item-price tabular">' + cdEsc(cdMoney(li.final_line_price)) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-drawer__item-remove" data-cd-rm>Remove</button>' +
        '</div>' +
      '</li>';
    }

    function render(cart) {
      if (!cart) return;
      var count = cart.item_count || 0;
      syncCount(count);
      if (count === 0) {
        if (cdItems) cdItems.innerHTML = '';
        if (cdEmpty) cdEmpty.hidden = false;
        if (cdFoot) cdFoot.hidden = true;
        if (cdShip) cdShip.hidden = true;
        if (cdRecs) cdRecs.hidden = true;
        return;
      }
      if (cdEmpty) cdEmpty.hidden = true;
      if (cdFoot) cdFoot.hidden = false;
      if (cdItems) cdItems.innerHTML = (cart.items || []).map(function (li, i) { return itemHTML(li, i + 1); }).join('');
      if (cdSub) cdSub.textContent = cdMoney(cart.total_price);   // amount before shipping/tax
      renderShip(cart.total_price || 0);
      renderRecs(cart);
    }

    /* ---- open / close ---- */
    var cdLastFocus = null;
    function openPanel() {
      cdLastFocus = document.activeElement;
      cdClearError();
      cdRoot.hidden = false;
      // Force a synchronous style flush by READING offsetWidth. NOT requestAnimationFrame:
      // rAF does not fire in a background/unfocused tab, so the panel would stay at
      // translateX(100%) and look like it failed to open. Reading offsetWidth flushes style
      // now and the CSS transition still runs.
      void cdRoot.offsetWidth;
      cdRoot.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = $('.cart-drawer__x', cdRoot);
      if (closeBtn) closeBtn.focus();
    }
    function openDrawer() {
      openPanel();
      cdBusyOn(true);
      getCart().then(render).catch(function () {}).then(function () { cdBusyOn(false); });
    }
    function closeDrawer() {
      cdRoot.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { cdRoot.hidden = true; }, 280);   // match the CSS transition
      if (cdLastFocus && cdLastFocus.focus) cdLastFocus.focus();
    }

    cdRoot.addEventListener('click', function (e) {
      // The scrim and the X carry data-cd-close (both non-navigating), so preventing default
      // here is safe. The empty-state "Start shopping" link is intentionally NOT a close target.
      if (e.target.closest('[data-cd-close]')) { e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !cdRoot.hidden) closeDrawer();
    });
    // Basic focus trap: if focus leaves the panel while open, pull it back.
    document.addEventListener('focusin', function (e) {
      if (cdRoot.hidden || !cdRoot.classList.contains('is-open')) return;
      if (cdPanel && !cdPanel.contains(e.target)) {
        var f = cdPanel.querySelector('button, a[href], input, [tabindex]');
        if (f) f.focus();
      }
    });

    /* ---- header cart icon opens the drawer (href="/cart" stays the no-JS fallback) ---- */
    $$('[data-cart-toggle]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;  // let new-tab clicks through
        e.preventDefault();
        openDrawer();
      });
    });

    /* ---- line-item quantity + remove (delegated; innerHTML is rewritten each render) ---- */
    if (cdItems) {
      cdItems.addEventListener('click', function (e) {
        var row = e.target.closest('[data-line]');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-line'), 10);   // /cart/change.js is 1-based
        var numEl = row.querySelector('.cart-drawer__qty-num');
        var q = parseInt(numEl ? numEl.textContent : '1', 10) || 1;
        var next = null;
        if (e.target.closest('[data-cd-inc]')) next = q + 1;
        else if (e.target.closest('[data-cd-dec]')) next = q - 1;
        else if (e.target.closest('[data-cd-rm]')) next = 0;
        if (next === null) return;
        cdClearError();
        cdBusyOn(true);
        cdApi(CHG_URL, { line: line, quantity: Math.max(0, next) })
          .then(function (c) { render(c); })
          .catch(function (err) { if (err && err.cdError) cdShowError(err.description || 'Could not update the quantity.'); })
          .then(function () { cdBusyOn(false); });
      });
    }

    /* ---- recommendation "Add" buttons (delegated) ---- */
    if (cdRecList) {
      cdRecList.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cd-recadd]');
        if (!btn) return;
        var id = btn.getAttribute('data-id');
        if (!id) return;
        cdClearError();
        cdBusyOn(true);
        cdApi(ADD_URL, { items: [{ id: id, quantity: 1 }] })
          .then(function () { return getCart().then(render); })
          .catch(function (err) { if (err && err.cdError) cdShowError(err.description || 'Could not add that item.'); })
          .then(function () { cdBusyOn(false); });
      });
    }

    /* ---- THE product buy form: the single submit owner ---- */
    var cdAtc = $('[data-add-to-cart]');
    var cdBuyForm = cdAtc ? cdAtc.closest('form') : null;
    if (cdBuyForm) {
      cdBuyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (cdBuyForm.getAttribute('data-cd-adding')) return;      // guard double-submit

        var fd = new FormData(cdBuyForm);
        var id = fd.get('id');
        if (!id) return;                                           // validate
        var qty = parseInt(fd.get('quantity') || '1', 10) || 1;

        var item = { id: id, quantity: qty };
        var props = {};
        fd.forEach(function (val, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && String(val).length) props[m[1]] = val;
        });
        if (Object.keys(props).length) item.properties = props;
        var sp = fd.get('selling_plan');
        if (sp) item.selling_plan = sp;

        cdBuyForm.setAttribute('data-cd-adding', '1');
        openPanel();
        cdBusyOn(true);
        cdApi(ADD_URL, { items: [item] })
          .then(function () { return getCart().then(render); })   // reflect the true cart
          .catch(function (err) {
            if (err && err.cdError) {
              // Shopify rejected the add (e.g. not enough stock). Show why and reflect the
              // real cart — do NOT present it as added.
              cdShowError(err.description || 'Sorry — that item could not be added.');
              return getCart().then(render);
            }
            cdBuyForm.submit();                                   // network fail: native POST (no submit event → no re-entry)
          })
          .then(function () { cdBuyForm.removeAttribute('data-cd-adding'); cdBusyOn(false); });
      });
    }
  }
})();
